import React, { useState } from 'react';
import { useTranslate } from '@hooks';
import classnames from 'classnames';
import Highlight from 'react-highlight';
import { TabSet } from '@dotone/react-ui-core';

const DocsResponseTabset = ({ codes = {}, ...otherProps }) => {
  const { t } = useTranslate('docs', 'response');
  const [activeTab, setActiveTab] = useState('json');

  return (
    <div {...otherProps}>
      <div className="d-flex align-items-end">
        <h6 className="text-dark-light">
          {t('title')}
          <strong className="text-dark text-sm ml-1">({t(`formats.${activeTab}`)})</strong>
        </h6>
        <TabSet
          card={false}
          activeTab={activeTab}
          items={{ json: 'JSON', xml: 'XML' }}
          navProps={{
            pills: true,
            className: 'custom-pills font-medium',
            linkProps: { className: 'py-1' },
          }}
          onToggle={setActiveTab}
          className="ml-auto"
        />
      </div>
      <div className={classnames({ 'd-none': activeTab !== 'json' })}>
        <Highlight className="json">{codes.json}</Highlight>
      </div>
      <div className={classnames({ 'd-none': activeTab !== 'xml' })}>
        <Highlight className="xml">{codes.xml}</Highlight>
      </div>
    </div>
  );
};

export default DocsResponseTabset;
